export const chargeStatusText = (status) => ({
    NOT_CHARGED: "未扣费", CHARGED: "已扣费", REFUNDED: "已退款",
}[status] || "未知");

export const chargeStatusType = (status) => ({
    NOT_CHARGED: "info", CHARGED: "success", REFUNDED: "warning",
}[status] || "info");

// 金额单位为分；售价只有在订单已扣费或已退款时才计入原扣费。
export function billingAmounts(status, amount) {
    if (status === "NOT_CHARGED") return { original: 0, refund: 0, net: 0 };
    const value = amount === null || amount === undefined || amount === "" ? NaN : Number(amount);
    const original = Number.isFinite(value) && value >= 0 ? value : null;
    if (status === "REFUNDED") return { original, refund: original, net: 0 };
    if (status === "CHARGED") return { original, refund: 0, net: original };
    return { original: null, refund: null, net: null };
}
